<template>
  <div class="div7" id="schedule" style="position: relative; z-index: 1">
    <header v-if="backHeader">
      <div class="header-elements">
        <h4 class="back" @click="goToReserveSelect">＜ 戻る</h4>
      </div>
    </header>
    <div v-if="backHeader" class="margin-bottom-48"></div>
    <div class="sd header">
      <div class="sd title">
        <div class="sd t1">
          <h2 class="sd text-standard1 text">予約情報</h2>
        </div>
        <div class="sd line"></div>
      </div>
    </div>
    <div class="sd content background-white height-auto">
        <table class="table" :style="{ fontSize: fontSize + 'px' }" >
          <thead>
            <tr>
              <th>イベント名</th>
              <th>内容</th>
              <th>利用可能ゲーム</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>平日18禁Day</td>
              <td>水・木・金の12~19時にサバゲー18禁のみ対応します<br/>（セルフのみ）</td>
              <td>試射・セルフ18禁サバゲー</td>
            </tr>
            <tr>
              <td>土日祝ナーフ10禁Day</td>
              <td>土日祝はナーフ10禁とさせていただきます<br/>（サバゲー18禁も相談可）<br/>9:00~16:30(【お昼休憩】12:00~13:00)</td>
              <td>ナーフ・サバゲー10禁・試射・セルフ18禁サバゲー<br/>※サバゲー18禁要相談</td>
            </tr>
            <tr>
              <td><span style="font-size: 0.8em">月１開催きょーちゃんと一緒</span><br/>18歳以上サバゲー</td>
              <td>月一で開催される41PXきょーちゃん主催のイベント「きょーちゃん18禁Day」</td>
              <td>サバゲー18禁・試射・セルフ18禁サバゲー</td>
            </tr>
          </tbody>
        </table>
        <p fontSize="20" width=80%>営業時間以外のイベントの開催がある場合、カレンダーに開催時刻が表示されます。
          <br/>上記以外のイベントにつきましては、X・インスタグラムにて詳細をお知らせいたします。</p>
      </div>
    <div class="sd content background-white height-auto">
      <div class="sd content-t4-s3-sm1">
        <p class="sd text text-value1 text-align-left" style="color: #009aff">
          予約したい日付をクリックして予約画面に進んでください。日付をクリックすることで予約者と各人数を確認することも出来ます。
        </p>
      </div>
      <div class="sd content-t3 height-auto">
        <MyCalendar
          @calendar-item-loaded="updateCalendarItem"
          @go-to-reserve="goToReserve"
        />
      </div>
    </div>
  </div>
</template>

<script>
import MyCalendar from "@/components/MyCalendar.vue";
import {
  checkLoginInfo,
  getQueryParam,
  navigateToPage,
} from "@/modules/common";
export default {
  name: "ReserveCalendar",
  props: ["fromMyPage"],
  components: {
    MyCalendar,
  },
  mounted() {
    if (getQueryParam("backpress")) {
      this.goToReserveSelect();
      return;
    }
    window.addEventListener('resize', this.updateFontSize)
    this.updateFontSize()
    this.initialize();
  },  
  beforeUnmount() {
    window.removeEventListener('resize', this.updateFontSize)
  },
  created() {
    this.backHeader = this.$route.params.fromMyPage == 1;
  },
  data() {
    return {
      CalendarItem: [],
      Month: "",
      Year: "",
      backHeader: false,
      fontSize:12,
    };
  },
  methods: {
    async initialize() {
      // ログイン状態であればユーザーIDを取得してidに格納し、会員情報を取得して入力欄に格納
      const sessionUserId = localStorage.getItem("sessionUserId");
      const login_hash = localStorage.getItem("login_hash");
      const login_time = localStorage.getItem("login_time");
      if (await checkLoginInfo(sessionUserId, login_hash, login_time)) {
        this.login = true;
      }
    },
    goToReserveSelect() {
      navigateToPage("reserve-select");
    },
    goToReserve(selectedDate) {
      this.$router.push({
        name: "temporaryBooking",
        params: {
          selectedDate: selectedDate,
          fromMyPage: this.backHeader ? 1 : 0,
        },
      });
    },
    updateCalendarItem(month, year, calendarItem) {
      if (calendarItem == null || Array.isArray(calendarItem))
        this.CalendarItem = calendarItem;
      else {
        this.CalendarItem = [];
        this.CalendarItem.push(calendarItem);
      }

      this.Month = month + 1;
      this.Year = year;
    },
    updateFontSize() {
      const width = window.innerWidth
      this.fontSize = Math.max(2, Math.min(width / 55, 25))
    },
  },
};
</script>

<style scoped src="@/assets/css/mypage.css"></style>

<style scoped>
.header-elements {
  background-color: white;
}
.header-elements .back {
  color: black;
}
.back:hover {
  border-bottom: 1px solid black;
}

.calendar_description li {
  font-weight: bold;
}

.sd.content.background-white.height-auto {
  background-color: #fff;
  padding: 20px;
  height: auto;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
}

.table {
  width: 90%;
  border-collapse: collapse;
  margin-top: 10px;
}

.table th,
.table td {
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
  vertical-align: top;
}

.table th {
  background-color: #009aff;
  font-weight: bold;
  color: #ffffff;
  text-align: center;          /* 横方向：中央 */
  vertical-align: middle;      /* 縦方向：中央 */
}
.table td:first-child {
  width: 20%;
  background-color: #ff8700; /* 明るい水色例 */
  font-weight: bold;
  color: #ffffff;
  text-align: center;          /* 横方向：中央 */
  vertical-align: middle;      /* 縦方向：中央 */
}
.table td:last-child{
  width: 28%;
}
</style>
